import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

const GroupedCardsItem = ({ children, className, index }) => {
  const divClassNames = classnames('grouped_card__item', className, {
    '-first': index === 0
  });

  return <div className={divClassNames}>{children}</div>;
};

GroupedCardsItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  index: PropTypes.number
};

export default GroupedCardsItem;
